// extracted by mini-css-extract-plugin
export default {"ut":"index_ut__aTdeL","manage":"index_manage__4Xei6"};